import React from 'react';
const MediaMarketingSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-jump-out-media-marketing" });
MediaMarketingSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-jump-out-media-marketing sirius-icon-jump-out-media-marketing-enhance" });
export default MediaMarketingSvg;
